import style from './style.module.css';

const Button = ({ text, link, type = "default", icon = "none", TAG = "a", disabled = false }) => {
    const Icon = icon === 'cart' ? <img src="img/cart.png" alt="cart icon" /> : null;

    const className = [
        type === 'default' ? style.button : style.button_white,
        disabled && style.button_disabled
    ].filter(Boolean).join(' ');

    // Функция, чтобы блокировать клики и все связанные с ними события
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    if (TAG === 'a') {
        return (
            <a
                href={disabled ? undefined : link}
                className={className}
                aria-disabled={disabled}
                onClick={handleClick}
                tabIndex={disabled ? -1 : 0}
                role="button"
            >
                {Icon}
                {text}
            </a>
        );
    }

    return (
        <TAG
            className={className}
            disabled={disabled}
            onClick={handleClick}
            tabIndex={disabled ? -1 : 0}
        >
            {Icon}
            {text}
        </TAG>
    );
};

export default Button;
